
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.578 16.778V5.609L12.9.025v4.294l3.797 2.184c.15.074.15.297 0 .372L12.18 9.48a.427.427 0 01-.422 0L7.24 6.85c-.149-.075-.149-.299 0-.373l3.798-2.184V0l-9.68 5.584v11.194-.05.05l3.723-2.135V10.25c0-.149.174-.273.323-.174l4.517 2.606a.461.461 0 01.223.373v5.212c0 .149-.174.273-.323.174l-3.797-2.184-3.723 2.134 9.68 5.584 9.68-5.584-3.724-2.134-3.797 2.183c-.124.075-.323-.024-.323-.173v-5.212a.41.41 0 01.224-.373l4.517-2.606c.124-.074.322.025.322.174v4.393l3.698 2.135z","fill":"#4C4C4C"}}),_c('path',{attrs:{"d":"M11.956 24l9.68-5.584-3.723-2.134-3.798 2.184c-.124.074-.322-.025-.322-.174V13.08a.41.41 0 01.223-.372l4.517-2.606c.124-.075.323.024.323.173v4.393l3.722 2.135V5.609l-10.622 6.13V24z","fill":"#000"}}),_c('path',{attrs:{"d":"M12.874 0v4.294l3.798 2.184c.148.074.148.298 0 .372l-4.518 2.606a.426.426 0 01-.421 0L7.24 6.85c-.149-.074-.149-.298 0-.372l3.798-2.184V0l-9.68 5.584 10.623 6.13 10.622-6.13L12.874 0z","fill":"gray"}}),_c('path',{attrs:{"d":"M9.772 18.44l-3.797-2.183-3.723 2.134 9.68 5.585V11.715L1.332 5.609v11.194-.05.05l3.723-2.135v-4.393c0-.149.174-.273.323-.173l4.517 2.606a.461.461 0 01.223.372v5.212c-.024.124-.198.223-.347.149z","fill":"#4C4C4C"}})])
          )
        }
      }
    